import { STORAGE_KEY } from '@/constant/constant';
import { commonApi, companyUUID, getShopifyUserId } from '../service/api';
import { terminal } from '../constant/index';
import { showAPop } from '../service/strategy/priority';
import { formEventV2 } from '../service/formEventV2';
import { getLocal, setSession } from '@/utils/storage';

/**
 * 弹窗曝光上报：commonApi view + formEventV2 popup_view
 * @param isCover 是否为封面步骤，封面用 step=-1，否则 step=1
 */
export function reportPopupView(params: {
  id: string;
  name: string;
  triggerEventType: number;
  /** true 为封面步骤 step=-1，否则 step=1 */
  isCover: boolean;
  templateId?: string;
  responseData?: any;
  /** 触发来源（如 leaveBeta） */
  triggerSource?: string;
}) {
  const { id, name, triggerEventType, isCover, templateId, responseData, triggerSource } = params;
  /** 曝光步骤：封面 -1，主内容 1 */
  const step = isCover ? -1 : 1;
  /** AB 实验映射，用于 view 接口 */
  const info = getLocal(STORAGE_KEY.AB_MAP);
  let abMapping: any = null;
  if (info) {
    try {
      abMapping = JSON.parse(info);
    } catch (_) {}
  }

  showAPop(triggerEventType, responseData?.id);
  // 新用户订阅(type=0)且由 leaveBeta 触发：记录最近展示时间，用于按 displayFrequency 决定下次优先级
  if (triggerEventType === 0 && triggerSource === 'leaveBeta') {
    setSession(STORAGE_KEY.LEAVE_BETA_TYPE0_LAST_SHOWN_AT, `${Date.now()}`);
  }

  commonApi(
    {
      cid: getLocal(STORAGE_KEY.CID) || null,
      formUid: getLocal(STORAGE_KEY.FORM_UID) || null,
      pathname: window.location.pathname,
      event: 'view',
      companyUUID: companyUUID,
      shopifyUserId: getShopifyUserId(),
      userAgent: navigator.userAgent,
      formId: id,
      step,
      terminal: terminal ? 'pc' : 'mobile',
      abMapping: abMapping
    },
    'form/out/view'
  ).catch(() => {});

  formEventV2({
    event: 'popup_view',
    triggerEventType,
    showFrom: localStorage?.getItem('_cartsee_show_from') || '',
    formId: id,
    formName: name,
    step,
    templateId: templateId != null ? Number(templateId) : undefined,
    pixel: window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0,
    // 仅离开意图(1) 时上报离开子类型
    leaveTriggerType: triggerEventType === 1 ? window?.sessionStorage?.getItem('leaveTriggerType') || '' : ''
  }).then(() => {
    window?.sessionStorage?.setItem('leaveTriggerType', '');
  }).catch(() => {});
}
